/* global css */
import React from 'react';
import cx from 'classnames';
import { cssInJS } from '../../utils/styles';

interface Props {
  label: string,
  className?: string,
}

const FieldLabel: React.FC<Props> = ({
  label,
  className = '',
}: Props) => {
  // @ts-ignore
  const style = css(styles.labelStyle);

  return (
    <div className={cx(style, className)}>{label}</div>
  );
};

const styles = cssInJS({
  labelStyle: {
    width: '40%',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: '12px',
  },
});

export default FieldLabel;
